export const Hero = ({ banner }) => {
  return (
    <section className="w-full overflow-hidden" data-testid="hero-section">
      <img
        src={banner.desktop}
        alt=""
        className="hidden md:block w-full h-auto"
        fetchpriority="high"
        data-testid="hero-banner-desktop"
      />
      <img
        src={banner.mobile}
        alt=""
        className="block md:hidden w-full h-auto"
        data-testid="hero-banner-mobile"
      />
    </section>
  );
};
